import PropTypes from 'prop-types';
import InnerFormSection from 'components/ui-components/forms/InnerFormSection';
import HookFormPostcodeSelector from 'components/cef_form/hook-form/HookFormPostcodeSelector';

const PreviousAddressSelector = ({
  postcodeSearched,
  setPostcodeSearched,
  setPostcodeIsReset,
  addressDataModel,
  persistedData,
}) => (
  <InnerFormSection
    title="Previous Home Address"
    description="As you have not been at your current address for more than 3 years, please supply your previous address.">
    <HookFormPostcodeSelector
      className="mt-20"
      id="previous"
      postcodeSearched={postcodeSearched}
      setPostcodeSearched={setPostcodeSearched}
      setPostcodeIsReset={setPostcodeIsReset}
      addressDataModel={addressDataModel}
      persistedData={persistedData}
    />
  </InnerFormSection>
);

PreviousAddressSelector.propTypes = {
  postcodeSearched: PropTypes.bool.isRequired,
  setPostcodeSearched: PropTypes.func,
  addressDataModel: PropTypes.shape({
    'addresses.2.house_number': PropTypes.string,
    'addresses.2.address_line_1': PropTypes.string,
    'addresses.2.address_line_2': PropTypes.string,
    'addresses.2.address_line_3': PropTypes.string,
    'addresses.2.address_line_4': PropTypes.string,
    'addresses.2.postcode': PropTypes.string,
  }),
  persistedData: PropTypes.shape({
    house_number: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    address_line_3: PropTypes.string,
    address_line_4: PropTypes.string,
    postcode: PropTypes.string,
  }),
};

export default PreviousAddressSelector;
